import React from 'react';
import './CardButton.css';

const CardButton = ({
  onClick,
  className = '',
  size = 'medium',
  disabled = false,
}) => {
  return (
    <button
      className={`card-button card-button--${size} ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.56758 1.05523e-06L15.8568 0C16.4882 6.59524e-07 17 0.511848 17 1.14324L17 11.4324C17 12.0638 16.4882 12.5757 15.8568 12.5757C15.2254 12.5757 14.7135 12.0638 14.7135 11.4324V3.90327L1.61679 17L0 15.3832L13.0967 2.28648H5.56758C4.93619 2.28648 4.42434 1.77464 4.42434 1.14324C4.42434 0.511847 4.93619 1.05523e-06 5.56758 1.05523e-06Z"
          fill="currentColor"
        />
      </svg>
    </button>
  );
};

export default CardButton;
